import React from "react";
import { useTranslation } from 'react-i18next';

/**
 * Visar info om hur många stipendier som är utlysta (number), vilken summa som
 * utlysts (amount) och vilken typ av belopp (type), t ex engångssumma, årsbelopp.
 */
export default function AmountInfo({number, amount, type}) {
    const { t, i18n } = useTranslation();

    return (
        <>
        {(number === 0 || number === '') && t('scholarship.not_fixed_number_with_announced_amount')}
        {number > 0 && number}
        {number === 1 && t('scholarship.scholarship_with_announced_amount')}
        {number > 1 && t('scholarship.scholarships_with_announced_amount')}
            {Number(amount).toLocaleString(i18n.resolvedLanguage)}{t('scholarship.sek')}
        {type && " ("}{type.toLowerCase()}{type && ")"}
        </>
);
}